import React, { useState } from 'react';
import { Section } from './Section';
import { Countdown } from './Countdown';
import { Button } from './Button';
import { Check, ShieldCheck, Zap, Clock, Circle, CheckCircle2 } from 'lucide-react';
export function PricingSection() {
  const [selectedOption, setSelectedOption] = useState<'standard' | 'elite'>('elite');
  const handleCheckout = () => {
    if (selectedOption === 'standard') {
      window.location.href = 'https://checkout.activadigital.store/cart/53084331147558:1';
    } else {
      window.location.href = 'https://checkout.activadigital.store/cart/53084332261670:1';
    }
  };
  return <Section id="pricing" className="relative !py-4 md:!py-12" data-id="element-230">
      <div className="max-w-4xl mx-auto" data-id="element-231">
        {/* Urgency Header */}
        <div className="text-center mb-3 md:mb-12 bg-navy-900 p-3 md:p-8 rounded-xl md:rounded-3xl border border-red-900/50 shadow-2xl" data-id="element-232">
          <h3 className="text-sm md:text-3xl font-heading font-bold text-white mb-1 md:mb-2" data-id="element-233">
            El precio de lanzamiento termina en:
          </h3>
          <Countdown data-id="element-234" />
          <p className="text-red-400 font-medium text-[11px] md:text-lg mt-1 md:mt-4" data-id="element-235">
            Después sube $8.000 ARS y no vuelve a bajar.
          </p>

          <div className="mt-2 md:mt-6 max-w-md mx-auto" data-id="element-236">
            <div className="flex justify-between text-[10px] md:text-sm font-bold mb-1 md:mb-2" data-id="element-237">
              <span className="text-white flex items-center gap-1 md:gap-2" data-id="element-238">
                <span className="w-1.5 h-1.5 md:w-2 md:h-2 rounded-full bg-red-500 animate-pulse" data-id="element-239"></span>{' '}
                Cupos promocionales
              </span>
              <span className="text-gold-400" data-id="element-240">68% tomados</span>
            </div>
            <div className="h-1.5 md:h-3 w-full bg-navy-800 rounded-full overflow-hidden" data-id="element-241">
              <div className="h-full bg-gradient-to-r from-gold-600 to-gold-400 w-[68%] rounded-full relative" data-id="element-242">
                <div className="absolute inset-0 bg-white/20 animate-[pulse_2s_ease-in-out_infinite]" data-id="element-243"></div>
              </div>
            </div>
          </div>
        </div>

        <div className="text-center mb-3 md:mb-10" data-id="element-244">
          <h2 className="text-lg md:text-4xl font-heading font-bold text-white mb-1 md:mb-4" data-id="element-245">
            Elegí tu Profe de Volley Resuelto:
          </h2>
          <p className="text-gray-300 text-[11px] md:text-base" data-id="element-246">
            Las dos opciones incluyen los 6 bonos estratégicos completos
          </p>
        </div>

        {/* Pricing Cards - Selectable - Always 2 columns */}
        <div className="grid grid-cols-2 gap-2 md:gap-6 items-stretch mb-4 md:mb-10" data-id="element-247">
          {/* Standard Option */}
          <div onClick={() => setSelectedOption('standard')} className={`cursor-pointer transition-all duration-300 rounded-xl md:rounded-3xl p-3 md:p-8 flex flex-col relative ${selectedOption === 'standard' ? 'bg-navy-800 border-2 border-gold-500 shadow-[0_0_30px_rgba(212,168,67,0.15)]' : 'bg-navy-800/50 border-2 border-navy-600 opacity-70 hover:opacity-100 hover:border-navy-500'}`} data-id="element-248">
            {/* Radio indicator */}
            <div className="absolute top-2 right-2 md:top-6 md:right-6" data-id="element-249">
              {selectedOption === 'standard' ? <CheckCircle2 className="w-4 h-4 md:w-8 md:h-8 text-gold-500" data-id="element-250" /> : <Circle className="w-4 h-4 md:w-8 md:h-8 text-navy-600" data-id="element-251" />}
            </div>

            <div className={`absolute -top-2 md:-top-4 left-1/2 -translate-x-1/2 px-2 py-0.5 md:px-4 md:py-1 rounded-full text-[8px] md:text-sm font-bold whitespace-nowrap transition-colors ${selectedOption === 'standard' ? 'bg-gold-500 text-navy-900' : 'bg-navy-600 text-white'}`} data-id="element-252">
              ESTÁNDAR
            </div>

            <h3 className="text-[11px] md:text-2xl font-heading font-bold text-white mb-0.5 md:mb-2 mt-3 md:mt-4 text-center pr-4 md:pr-8 leading-tight" data-id="element-253">
              📘 PROFE DE VOLLEY RESUELTO
            </h3>
            <p className="text-center text-gray-400 mb-2 md:mb-6 text-[9px] md:text-base" data-id="element-254">
              6 Tomos + 6 Bonos
            </p>

            <div className="text-center mb-2 md:mb-8" data-id="element-255">
              <span className="text-gray-500 line-through text-[10px] md:text-xl block" data-id="element-256">
                $34.990
              </span>
              <div className="flex items-center justify-center gap-1 md:gap-3" data-id="element-257">
                <span className="text-xl md:text-4xl font-heading font-bold text-white" data-id="element-258">
                  $19.990
                </span>
              </div>
              <span className="text-[9px] md:text-sm text-gray-400" data-id="element-259">ARS</span>
            </div>

            <div className="space-y-1 md:space-y-4 flex-grow" data-id="element-260">
              <div className="flex items-start gap-1 md:gap-3" data-id="element-261">
                <Check className={`w-3 h-3 md:w-5 md:h-5 shrink-0 mt-0.5 ${selectedOption === 'standard' ? 'text-green-400' : 'text-gray-500'}`} data-id="element-262" />
                <span className="text-gray-300 text-[10px] md:text-base leading-tight" data-id="element-263">
                  6 Tomos Completos
                </span>
              </div>
              <div className="flex items-start gap-1 md:gap-3" data-id="element-264">
                <Check className={`w-3 h-3 md:w-5 md:h-5 shrink-0 mt-0.5 ${selectedOption === 'standard' ? 'text-green-400' : 'text-gray-500'}`} data-id="element-265" />
                <span className="text-gray-300 text-[10px] md:text-base leading-tight" data-id="element-266">
                  6 Bonos Estratégicos
                </span>
              </div>
              <div className="flex items-start gap-1 md:gap-3" data-id="element-267">
                <Check className={`w-3 h-3 md:w-5 md:h-5 shrink-0 mt-0.5 ${selectedOption === 'standard' ? 'text-green-400' : 'text-gray-500'}`} data-id="element-268" />
                <span className="text-gray-300 text-[10px] md:text-base leading-tight" data-id="element-269">
                  Acceso de por vida
                </span>
              </div>
              <div className="flex items-start gap-1 md:gap-3" data-id="element-270">
                <Check className={`w-3 h-3 md:w-5 md:h-5 shrink-0 mt-0.5 ${selectedOption === 'standard' ? 'text-green-400' : 'text-gray-500'}`} data-id="element-271" />
                <span className="text-gray-300 text-[10px] md:text-base leading-tight" data-id="element-272">
                  Actualizaciones gratuitas
                </span>
              </div>
            </div>
          </div>

          {/* Elite Option */}
          <div onClick={() => setSelectedOption('elite')} className={`cursor-pointer transition-all duration-300 rounded-xl md:rounded-3xl p-3 md:p-8 flex flex-col relative ${selectedOption === 'elite' ? 'bg-gradient-to-b from-navy-800 to-navy-900 border-2 border-gold-500 shadow-[0_0_40px_rgba(212,168,67,0.2)]' : 'bg-navy-800/50 border-2 border-navy-600 opacity-70 hover:opacity-100 hover:border-navy-500'}`} data-id="element-273">
            {/* Radio indicator */}
            <div className="absolute top-2 right-2 md:top-6 md:right-6" data-id="element-274">
              {selectedOption === 'elite' ? <CheckCircle2 className="w-4 h-4 md:w-8 md:h-8 text-gold-500" data-id="element-275" /> : <Circle className="w-4 h-4 md:w-8 md:h-8 text-navy-600" data-id="element-276" />}
            </div>

            <div className={`absolute -top-2 md:-top-4 left-1/2 -translate-x-1/2 px-2 py-0.5 md:px-6 md:py-1 rounded-full text-[8px] md:text-sm font-bold whitespace-nowrap shadow-lg flex items-center gap-0.5 md:gap-2 transition-colors ${selectedOption === 'elite' ? 'bg-gold-500 text-navy-900' : 'bg-navy-600 text-white'}`} data-id="element-277">
              🔥 MÁS ELEGIDO
            </div>

            <h3 className={`text-[11px] md:text-2xl font-heading font-bold mb-0.5 md:mb-2 mt-3 md:mt-4 text-center pr-4 md:pr-8 leading-tight ${selectedOption === 'elite' ? 'text-gold-400' : 'text-white'}`} data-id="element-278">
              🏆 PACK ÉLITE™
            </h3>
            <p className="text-center text-gray-300 mb-2 md:mb-6 text-[8px] md:text-sm" data-id="element-279">
              6 Tomos + 6 Bonos + Academia + Profe Digital
            </p>

            <div className="text-center mb-2 md:mb-8" data-id="element-280">
              <span className="text-gray-500 line-through text-[10px] md:text-xl block" data-id="element-281">
                $43.990
              </span>
              <div className="flex items-center justify-center gap-1 md:gap-3" data-id="element-282">
                <span className="text-xl md:text-5xl font-heading font-bold text-white" data-id="element-283">
                  $27.990
                </span>
              </div>
              <span className="text-[9px] md:text-sm text-gray-400" data-id="element-284">ARS</span>
            </div>

            <div className="space-y-1 md:space-y-4 flex-grow" data-id="element-285">
              <div className="flex items-start gap-1 md:gap-3" data-id="element-286">
                <Check className={`w-3 h-3 md:w-5 md:h-5 shrink-0 mt-0.5 ${selectedOption === 'elite' ? 'text-gold-500' : 'text-gray-500'}`} data-id="element-287" />
                <span className="text-white font-medium text-[10px] md:text-base leading-tight" data-id="element-288">
                  Todo lo de Estándar
                </span>
              </div>
              <div className="flex items-start gap-1 md:gap-3" data-id="element-289">
                <Check className={`w-3 h-3 md:w-5 md:h-5 shrink-0 mt-0.5 ${selectedOption === 'elite' ? 'text-gold-500' : 'text-gray-500'}`} data-id="element-290" />
                <span className={`${selectedOption === 'elite' ? 'text-gold-400' : 'text-gray-300'} font-bold text-[10px] md:text-base leading-tight transition-colors`} data-id="element-291">
                  + Tu Academia de Volley
                </span>
              </div>
              <div className="flex items-start gap-1 md:gap-3" data-id="element-292">
                <Check className={`w-3 h-3 md:w-5 md:h-5 shrink-0 mt-0.5 ${selectedOption === 'elite' ? 'text-gold-500' : 'text-gray-500'}`} data-id="element-293" />
                <span className={`${selectedOption === 'elite' ? 'text-gold-400' : 'text-gray-300'} font-bold text-[10px] md:text-base leading-tight transition-colors`} data-id="element-294">
                  + Profe Digital (Redes)
                </span>
              </div>
            </div>

            <p className="text-center text-[8px] md:text-sm text-gray-400 italic mt-2 md:mt-auto hidden md:block" data-id="element-295">
              "La más elegida por profes que quieren profesionalismo total"
            </p>
          </div>
        </div>

        {/* Single CTA Button */}
        <div className="max-w-xl mx-auto text-center" data-id="element-296">
          <Button size="xl" fullWidth onClick={handleCheckout} className="mb-3 shadow-[0_0_30px_rgba(250,204,21,0.25)] hover:shadow-[0_0_40px_rgba(250,204,21,0.4)] transition-shadow duration-300 animate-pulse-slow text-sm md:text-xl" data-id="element-297">
            {selectedOption === 'elite' ? '💥 QUIERO EL PACK ÉLITE' : '💥 QUIERO LA OPCIÓN ESTÁNDAR'}
          </Button>

          <div className="flex flex-wrap justify-center gap-x-3 gap-y-1 md:gap-x-6 md:gap-y-2 text-[10px] md:text-sm text-gray-400" data-id="element-298">
            <span className="flex items-center gap-1" data-id="element-299">
              <ShieldCheck className="w-3 h-3 md:w-4 md:h-4 text-gold-500" data-id="element-300" />{' '}
              Pago seguro
            </span>
            <span className="flex items-center gap-1" data-id="element-301">
              <Zap className="w-3 h-3 md:w-4 md:h-4 text-gold-500" data-id="element-302" /> Acceso
              inmediato
            </span>
            <span className="flex items-center gap-1" data-id="element-303">
              <Clock className="w-3 h-3 md:w-4 md:h-4 text-gold-500" data-id="element-304" /> Garantía
              7 días
            </span>
          </div>
        </div>
      </div>
    </Section>;
}